import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { lockScroll, unlockScroll } from '../../scrollLock';

function IconClose() {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M6 6l12 12M18 6L6 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function MobileResponsibleLimitConfirm({
  open,
  title,
  paragraphs,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  loading = false,
}) {
  useEffect(() => {
    if (!open) return undefined;
    lockScroll();
    return () => unlockScroll();
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="mobile-limit-confirm-dialog">
      <div className="mobile-limit-confirm-dialog__overlay" onClick={onCancel} />
      <div
        id="mobile-limit-confirm-window"
        className={`mobile-limit-confirm-dialog__window${paragraphs?.length ? '' : ' mobile-limit-confirm-dialog__window--compact'}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-limit-confirm-title"
      >
        <button
          type="button"
          className="mobile-limit-confirm-dialog__close"
          onClick={onCancel}
          aria-label={cancelLabel}
        >
          <IconClose />
        </button>
        <div className="mobile-limit-confirm-dialog__content">
          <span id="mobile-limit-confirm-title" className="mobile-limit-confirm-dialog__title">
            {title}
          </span>
          {paragraphs?.length ? (
            <div className="mobile-limit-confirm-dialog__message">
              {paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          ) : null}
          <div className="mobile-limit-confirm-dialog__buttons">
            <button
              type="button"
              className="mobile-limit-confirm-dialog__btn mobile-limit-confirm-dialog__btn--primary"
              onClick={onConfirm}
              disabled={loading}
            >
              {confirmLabel}
            </button>
            <button
              type="button"
              className="mobile-limit-confirm-dialog__btn mobile-limit-confirm-dialog__btn--secondary"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelLabel}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
